import { motion } from "framer-motion";
import Reveal from "../Reveal";

// ------------------------------------------------------------------
// EDIT ME: set useVideo=true and provide a videoSrc to use a video
// background/element instead of the placeholder image.
// ------------------------------------------------------------------
const useVideo = false;
const videoSrc = "/media/hero-video.mp4";
const imageSrc =
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200&auto=format&fit=crop";

const timelineData = [
  {
    icon: "AI",
    title: "AI",
    description: "Memahami & merespons",
    color: "text-orange-400",
    lineColor: "bg-orange-400",
  },
  {
    icon: "SW",
    title: "Software",
    description: "Mengelola data",
    color: "text-cyan-400",
    lineColor: "bg-cyan-400",
  },
  {
    icon: "IoT",
    title: "IoT",
    description: "Menghubungkan mesin & perangkat",
    color: "text-orange-400",
    lineColor: "bg-orange-400",
  },
  {
    icon: "DT",
    title: "Data & Intelligence",
    description: "Mengubah data jadi keputusan",
    color: "text-cyan-400",
    lineColor: "bg-cyan-400",
  },
  {
    icon: "EN",
    title: "Energy",
    description: "Mengukur & menghemat",
    color: "text-orange-400",
    lineColor: "bg-orange-400",
  },
  {
    icon: "AT",
    title: "Automation",
    description: "Menjalankan otomatis",
    color: "text-cyan-400",
    lineColor: "bg-cyan-400",
  },
  {
    icon: "RB",
    title: "Robotics",
    description: "Bertindak secara mandiri",
    color: "text-orange-400",
    lineColor: "bg-orange-400",
  },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="section min-h-screen flex items-center pt-32 md:pt-24 bg-radial-fade"
    >
      {/* Ambient animated gradient blobs -- purely decorative */}
      <div className="bg-blob w-72 h-72 bg-teal/40 -top-10 -left-10" />
      <div
        className="bg-blob w-96 h-96 bg-blue/40 top-1/3 right-0"
        style={{ animationDelay: "2s" }}
      />

      <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center w-full">
        <div>
          <Reveal direction="up">
            <span className="section-eyebrow">Technology Holding Company</span>
          </Reveal>

          <Reveal direction="up" delay={0.1}>
            <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.1] mb-6">
              Winning {" "}
              <span className="text-gradient">The Revolution</span>
            </h1>
          </Reveal>

          <Reveal direction="up" delay={0.2}>
            <p className="section-desc mb-8 text-white">
              WINREVO membantu bisnis dan industri menggunakan teknologi — AI, IoT, software, energy, automation, hingga robotics — untuk bekerja lebih cepat, lebih efisien, dan lebih menguntungkan.
            </p>
          </Reveal>

          <Reveal direction="up" delay={0.3}>
            <div className="flex flex-wrap gap-4">
              <a href="#about" className="btn-primary">
                Jelajahi Ekosistem
              </a>
              <a href="#cta" className="btn-secondary">
                Hubungi Kami
              </a>
            </div>
          </Reveal>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute bg-brand-gradient bg-200 animate-gradient-shift blur-2xl opacity-30" />
            <div className="relative overflow-hidden animate-float">
              {useVideo ? (
                <video
                  src={videoSrc}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full aspect-[4/3] object-cover"
                />
              ) : (
                <div className="relative w-full p-8">
                  <div className="absolute left-[40px] top-0 bottom-0 w-px bg-gradient-to-b from-cyan-400/40 via-cyan-400/30 to-orange-400/40" />
                  <div className="relative flex flex-col gap-7">
                    {timelineData.map((item, index) => (
                      <div
                        key={index}
                        className="relative flex items-center min-h-[56px]"
                      >
                        <div
                          className={`
                            relative z-10
                            flex items-center justify-center
                            w-[40px] h-[40px]
                            rounded-[3px]
                            border border-slate-600
                            bg-[#151c23]
                            text-[11px]
                            font-medium
                            ${item.color}
                            shadow-[0_0_15px_rgba(0,0,0,0.25)]
                          `}
                        >
                          {item.icon}
                        </div>

                        {/* Content */}
                        <div className="ml-4">
                          <h3 className="text-[14px] font-semibold text-white">
                            {item.title}
                          </h3>
                          <p className="mt-1 text-[12px] text-slate-400">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
